import * as React from "react";
import { cx } from "../internal/cx.js";

export type EnrollmentFlowMainWidth = "default" | "narrow" | "compact" | "centered";

export interface EnrollmentFlowMainProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  /**
   * Width preset for setup-step content.
   * - `default` — max 6xl (1152px)
   * - `narrow` / `centered` — max 3xl
   * - `compact` — max xl (loading / focused forms)
   */
  width?: EnrollmentFlowMainWidth;
}

const WIDTH_CLASS: Record<EnrollmentFlowMainWidth, string> = {
  default: "cw-v2-enrollment-flow-main--default",
  narrow: "cw-v2-enrollment-flow-main--narrow",
  compact: "cw-v2-enrollment-flow-main--compact",
  centered: "cw-v2-enrollment-flow-main--centered",
};

/**
 * Main content shell for multi-step enrollment flows (business details,
 * employees, bundle builder, etc.). Pair with `StepIndicator` above and
 * `Footer` below on the page.
 */
export const EnrollmentFlowMain = React.forwardRef<HTMLElement, EnrollmentFlowMainProps>(
  function EnrollmentFlowMain({ children, className, width = "default", ...props }, ref) {
    return (
      <main
        ref={ref}
        className={cx("cw-v2-enrollment-flow-main", WIDTH_CLASS[width], className)}
        {...props}
      >
        {width === "centered" ? (
          <div className="cw-v2-enrollment-flow-main__centered-inner">{children}</div>
        ) : (
          children
        )}
      </main>
    );
  },
);
EnrollmentFlowMain.displayName = "EnrollmentFlowMain";
